<div class="action-list animate__animated animate__fadeInDown animate__faster">
    <div class="contenido">
        <a mat-button *ngIf="paso>=2 && paso!=3 && accion>0" class="bt" (click)="back()"
            style="position: absolute; top: 22px; left: 20px;">
            <span class="material-icons" style="font-size: 18px;line-height: 18px;">
                keyboard_arrow_left
                </span> Regresar</a>

        <h1 *ngIf="accion==0">Ayuda</h1>
        <h1 *ngIf="accion==1">¿Cómo crear un juego</h1>
        <h1 *ngIf="accion==2">Acerca del Plan Premium</h1>
        <h1 *ngIf="accion==3 && paso==2">Escribe a nuestro soporte técnico</h1>
        <h1 *ngIf="paso==3 && accion==3">Correo enviado</h1>



        <div class="pasos">
            <span *ngIf="paso==1 ">¿Necesitas ayuda? Selecciona nuestras siguientes opciones de ayuda.</span>

        </div>
        <!--crear o selecionar de galeria (1,2) -->
        <div class="list-items2" *ngIf="paso==1">
            <div class="block-btn" [ngClass]="{'active': accion==1}" (click)="continuePaso(1)">
                <div class="border-i">
                    <img src="assets/img/transparente.png">
                    <h4>¿Cómo crear un </h4>
                    <h4>juego?</h4>
                </div>
            </div>
            <div class="block-btn" [ngClass]="{'active': accion==2}" (click)="continuePaso(2)">
                <div class="border-i">
                    <img src="assets/img/transparente.png">
                    <h4>Acérca del Plan </h4>
                    <h4>Premium</h4>
                </div>
            </div>
            <div class="block-btn" [ngClass]="{'active': accion==3}" (click)="continuePaso(3)">
                <div class="border-i">
                    <img src="assets/img/transparente.png">
                    <h4>Escribe a nuestro </h4>
                    <h4>soporte técnico</h4>
                </div>
            </div>
        </div>

        <!--paso 2 y accion2 | selecionar avatar -->
        <div *ngIf=" accion==1 && paso==2">

            <div class="selects">
                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Lorem ipsum
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. 
                            Quibusdam quisquam doloribus inventore earum accusantium 
                            aliquid ipsam, explicabo officiis, autem, ex neque dicta 
                            aspernatur eligendi nobis placeat hic fugit magni ipsum.</p>
                    </mat-expansion-panel>
                    <mat-expansion-panel >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Lorem ipsum
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. 
                            Quibusdam quisquam doloribus inventore earum accusantium 
                            aliquid ipsam, explicabo officiis, autem, ex neque dicta 
                            aspernatur eligendi nobis placeat hic fugit magni ipsum.</p>
                    </mat-expansion-panel>
                    <mat-expansion-panel >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Lorem ipsum
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. 
                            Quibusdam quisquam doloribus inventore earum accusantium 
                            aliquid ipsam, explicabo officiis, autem, ex neque dicta 
                            aspernatur eligendi nobis placeat hic fugit magni ipsum.</p>
                    </mat-expansion-panel>
                    <mat-expansion-panel >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Lorem ipsum
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. 
                            Quibusdam quisquam doloribus inventore earum accusantium 
                            aliquid ipsam, explicabo officiis, autem, ex neque dicta 
                            aspernatur eligendi nobis placeat hic fugit magni ipsum.</p>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>



        <div *ngIf="paso==2 && accion==2" class="paso3">
            <div class="selects">
                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Lorem ipsum
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. 
                            Quibusdam quisquam doloribus inventore earum accusantium 
                            aliquid ipsam, explicabo officiis, autem, ex neque dicta 
                            aspernatur eligendi nobis placeat hic fugit magni ipsum.</p>
                    </mat-expansion-panel>
                    <mat-expansion-panel >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Lorem ipsum
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. 
                            Quibusdam quisquam doloribus inventore earum accusantium 
                            aliquid ipsam, explicabo officiis, autem, ex neque dicta 
                            aspernatur eligendi nobis placeat hic fugit magni ipsum.</p>
                    </mat-expansion-panel>
                    <mat-expansion-panel >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Lorem ipsum
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. 
                            Quibusdam quisquam doloribus inventore earum accusantium 
                            aliquid ipsam, explicabo officiis, autem, ex neque dicta 
                            aspernatur eligendi nobis placeat hic fugit magni ipsum.</p>
                    </mat-expansion-panel>
                    <mat-expansion-panel >
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Lorem ipsum
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <p>Lorem, ipsum dolor sit amet consectetur adipisicing elit. 
                            Quibusdam quisquam doloribus inventore earum accusantium 
                            aliquid ipsam, explicabo officiis, autem, ex neque dicta 
                            aspernatur eligendi nobis placeat hic fugit magni ipsum.</p>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
        <!--paso 3 y accion2 | Finalizar -->
        <div *ngIf="paso==2 && accion==3" class="paso3">
            <h4 class="sub">Lorem ipsum lorem </h4>

            <mat-card-content>

                <input class="form-control" type="text" [(ngModel)]="motivo"
                    placeholder="Ingresa el motivo de tu consulta ">
                <textarea ngDefaultControl [(ngModel)]="consulta" placeholder="Describe tu consulta"></textarea>
            </mat-card-content>
        </div>

        <div *ngIf="paso==3 && accion==3" class="paso3">
            <h4 class="sub">Disfruta de tu nuevo paquete Primium lorem ipsum lorem ipsum</h4>

        </div>




        <div class="btn-action" *ngIf="!esperaFinal">
            <button *ngIf="paso==3 && accion==3" mat-button (click)="finalized()">CONTINUAR</button>

            <button *ngIf="paso==2 && accion==3" mat-button [disabled]="consulta.length<=2"
                (click)="emailHelp()">enviar</button>
        </div>
        <div class="btn-action" *ngIf="esperaFinal">
            <mat-progress-bar mode="query"></mat-progress-bar>
        </div>
        <button mat-button class="btn-close"><img src="assets/icons/plus.png" (click)="close()"></button>
    </div>
</div>